<template>
  <div>
    <CheckboxTeamInstruction
      name="counter-press"
      :value="defensiveTransition === 1"
      mutation="updateCounterPress"
      :incompatible="regroup"
    >
      {{ $t('tactics.instructions.transitions.defensive.counterPress') }}
    </CheckboxTeamInstruction>
    
    <CheckboxTeamInstruction
      name="regroup"
      :value="defensiveTransition === -1"
      mutation="updateRegroup"
      :incompatible="counterPress"
    >
      {{ $t('tactics.instructions.transitions.defensive.regroup') }}
    </CheckboxTeamInstruction>
  </div>
</template>

<script>
import CheckboxTeamInstruction from "@/components/CheckboxTeamInstruction";

export default {
  components: {
    CheckboxTeamInstruction
  },

  computed: {
    defensiveTransition () {
      return this.$store.state.instructions.inTransition.defensiveTransition;
    },

    counterPress () {
      return this.defensiveTransition === 1;
    },

    regroup () {
      return this.defensiveTransition === -1;
    }
  }
}
</script>

<style scoped>

</style>
